/* yp-design.js: smooth expand/collapse for FAQ cards (keeps native <details>/<summary>). 2026-10-04 */
(function(){
  if(window.__ypDesign)return;window.__ypDesign=true;
  var SEL='.collapsible-content .accordion details,.product__accordion details,.cli-q';
  var mq=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)');
  function body(d){var s=d.querySelector(':scope > summary');return s;}
  document.addEventListener('click',function(e){
    var s=e.target&&e.target.closest?e.target.closest('summary'):null;if(!s)return;
    var d=s.parentElement;if(!d||d.tagName!=='DETAILS'||!d.matches(SEL))return;
    if(e.target.closest('a,button,input')&&e.target.closest('a,button,input')!==s)return;
    if((mq&&mq.matches)||!d.animate)return;           /* native toggle */
    e.preventDefault();
    if(d.__ypA){d.__ypA.cancel();}
    var start=d.offsetHeight,end;d.classList.add('yp-anim');
    if(!d.open){d.open=true;end=d.offsetHeight;}else{end=s.offsetHeight;}
    var closing=end<start;
    var a=d.animate({height:[start+'px',end+'px']},{duration:Math.min(420,Math.max(220,Math.abs(end-start)*0.9)),easing:'cubic-bezier(.22,.61,.36,1)'});
    d.__ypA=a;
    a.onfinish=function(){d.__ypA=null;if(closing)d.open=false;d.classList.remove('yp-anim');d.style.height='';};
    a.oncancel=function(){d.__ypA=null;d.classList.remove('yp-anim');};
  });
})();
/* Page look (theme editor): re-apply when a main section is re-rendered, since inline scripts don't re-run there. */
(function(){
  function apply(){var m=document.querySelector('[data-yp-look]'),b=document.body;if(!m||!b||/(^|\s)yp-ds--t-index(\s|$)/.test(b.className))return;
    var l=m.getAttribute('data-yp-look');if(l==='default')l=b.getAttribute('data-yp-site-look')||'light';
    b.classList.remove('yp-ds--light','yp-ds--dark');b.classList.add('yp-ds--'+(l==='dark'?'dark':'light'));}
  document.addEventListener('shopify:section:load',apply);document.addEventListener('shopify:section:unload',function(){setTimeout(apply,0);});
})();
